module.exports = __webpack_public_path__ + "static/media/calendar-dark.52933747.svg";